
import InputControllerClass from '../classes/InputController.class.js';

import { initTriggerFormSection } from './TriggerFormSection';
import { initTriggerSetAttributes } from './TriggerSetAttributes';
import { initTriggerSlideNextClass } from './TriggerSlideNextClass';

const initTriggerController = function( scopeEl = document ) {

	// Initialise Slide Next Class Trigger.
	initTriggerSlideNextClass( scopeEl );

	// Initialise Form Section Trigger.
	initTriggerFormSection( scopeEl );

	// Initialise SetAttributes Trigger.
	initTriggerSetAttributes( scopeEl );
};

const initInputController = function() {
	var settings = {};
	settings.lengthCounter = {};
	settings.lengthCounter.pattern = '<span class="input_count_remaining">{remaining}</span>/<span class="input_count_max">{max}</span>';
	settings.lengthCounter.counterElement = 'span';
	settings.lengthCounter.counterClass = 'input_count';
	settings.lengthCounter.counterSelector = '.input_count_wrapper .input_count';

	const InputController = new InputControllerClass( settings );
	InputController.initLengthCounter( '.textarea[maxlength]' );
	InputController.setupGroupChangeEvent( 'input[type="radio"]' );
	InputController.setupGroupChangeEvent( 'input[type="checkbox"]' );

	return InputController;
};

export {
	initTriggerController,
	initTriggerFormSection,
	initTriggerSetAttributes,
	initTriggerSlideNextClass,
	initInputController
};
